<template>
    <div id="congratulation-content-example-data-section" class="w-100 d-flex flex-column justify-content-between align-items-center align-content-center">
        <div class="w-100 d-flex flex-row justify-content-between align-items-center align-content-center mb-3 data-container">
            <h6 class="text-left px-0 mb-0">
                Começar com dados de exemplo:
            </h6>
            <div class="text-right px-0">
                <div :class="`board-${shouldItBeFilled}`">
                    <ToggleButton
                    v-model="shouldItBeFilled"
                    :value="shouldItBeFilled"
                    class="mb-0"
                    @input="handleToggle"
                    v-bind="toggler"
                    />
                </div>
            </div>
        </div>
        <p id="congratulation-content-example-data-section-instructions" class="w-100 text-left">
            Comece sua jornada com dados de </br>
            exemplo no seu funil de vendas, para ter </br>
            um aprendizado facilitado no Salesflow.
        </p>
    </div>
</template>


<script>
export default {
    data () {
        return {
            shouldItBeFilled: true,
        };
    },

    computed: {
    toggler: () => ({
      'width': 32,
      'height': 16,
      'color': {
        checked: '#886AF8',
        unchecked: '#FFF',
      },
      'switch-color': {
        checked: '#ffffff',
        unchecked: '#BFBFBF',
      }
    }),
  },

    methods: {
        handleToggle(newValue) {
            this.$emit('toggle-changed', newValue);
        }
    }

}
</script>

<style lang="scss" scoped>
@import '../../../sass/variables';
@import '../../../sass/mixins';

#congratulation-content-example-data-section {
    background-color: $white-2;
    padding: 2.5rem 1.5rem;
    border: 1px solid $white-2;
    border-radius: 1rem;

    .data-container {
        height: 16px;
    }

    h6 {
        font-weight: 500;
        font-size: 1rem;
        line-height: 1.5rem;
        text-align: center;
        color: $salesflow-font-dark;
    }

    #congratulation-content-example-data-section-instructions {
        font-weight: 500;
        font-size: 1rem;
        line-height: 1.5rem;
        text-align: center;
        color: $salesflow-font-gray;
        margin-bottom: 0px;
        margin-top: -6px;
        height: 66px;
    }

    .board-true {
      width: fit-content;
      float: right;
    }

    .board-false {
      width: fit-content;
      border: 1px solid $gray-1;
      border-radius: 1rem;
      float: right;
    }
}

@media screen and (max-width: 428px) {
    #congratulation-content-example-data-section {
        padding: 2.5rem 1rem !important;
    }
}

@media screen and (max-width: 390px) {
    h6 {
        font-size: 15px !important;
    }

    #congratulation-content-example-data-section-instructions {
        font-size: 14px !important;

    }
}

@media screen and (max-width: 350px) {
    h6 {
        font-size: 14px !important;
    }

    #congratulation-content-example-data-section-instructions {
        font-size: 13px !important;

    }
}
</style>
